import postUserSettingsAction from 'owa-calendar-configuration/lib/services/postUserSettingsAction';
import TxpSettingsEntryPoint from 'owa-calendar-configuration/lib/store/schema/TxpSettingsEntryPoint';
import { isSuccessStatusCode } from 'owa-http-status-codes/lib/HttpStatusCode';
import { reloadTxpSettings, TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import updateLocalTxpSettings from 'owa-txp-option/lib/utils/updateLocalTxpSettings';
import getTxpSettingsSaveCustomData from 'owa-calendar-configuration/lib/utils/getTxpSettingsSaveCustomData';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';

export default async function sendChangedTxpSettings(
    changedSettings: TxpGriffinSettingsPayload,
    datapoint: PerformanceDatapoint
): Promise<boolean> {
    const response = await postUserSettingsAction(
        changedSettings,
        TxpSettingsEntryPoint.CardSettings,
        true /** isSettingsChange */
    );

    const customData = getTxpSettingsSaveCustomData(
        changedSettings,
        TxpSettingsEntryPoint.CardSettings
    );

    datapoint.addCustomData(customData);
    datapoint.addCustomData({ status: response.status });

    if (isSuccessStatusCode(response.status)) {
        reloadTxpSettings();
        updateLocalTxpSettings();
        datapoint.end();
        return true;
    } else {
        if (response.status >= 400 && response.status < 500) {
            // we don't end datapoints on statuses that are timeouts as they're automatically logged past 60s
            datapoint.endWithError(DatapointStatus.ClientError);
        } else {
            datapoint.endWithError(DatapointStatus.ServerError);
        }

        return false;
    }
}
